/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Price_LoadingInputs */

const en_mk_price_loading = /** @type {(inputs: Mk_Price_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading current plans…`)
};

const id_mk_price_loading = /** @type {(inputs: Mk_Price_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat paket terbaru…`)
};

/**
* | output |
* | --- |
* | "Loading current plans…" |
*
* @param {Mk_Price_LoadingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_loading = /** @type {((inputs?: Mk_Price_LoadingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_LoadingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_loading(inputs)
	return en_mk_price_loading(inputs)
});